import { contentTypeOptions, type CampaignBrief } from './types';

/** What production's BriefExtractionService returns; null for anything the brief doesn't state. */
export interface ExtractedBrief {
  name: string | null;
  description: string | null;
  content_type: string[];
  deliverables: string | null;
  terms: string | null;
  start_date: string | null;
  end_date: string | null;
  budget_per_creator: number | null;
  budget_currency: string | null;
  payment_terms: number | null;
}

const idByLabel = new Map(contentTypeOptions.map((option) => [option.label.toLowerCase(), option.id]));

/** The extracted fields as a patch for the wizard's brief; only what the brief stated. */
export function briefPatch(fields: ExtractedBrief): Partial<CampaignBrief> {
  const patch: Partial<CampaignBrief> = {};
  if (fields.name) patch.name = fields.name;
  if (fields.description) patch.description = fields.description;
  if (fields.deliverables) patch.deliverables = fields.deliverables;
  if (fields.start_date) patch.startDate = fields.start_date;
  if (fields.end_date) patch.endDate = fields.end_date;
  if (fields.budget_currency) patch.currency = fields.budget_currency;
  const types = (fields.content_type ?? [])
    .map((label) => idByLabel.get(String(label).toLowerCase()))
    .filter((id): id is string => Boolean(id));
  if (types.length > 0) patch.contentTypes = types;
  return patch;
}
